import React, { FormEvent, memo } from 'react';
import { UseFormMethods } from 'react-hook-form';
import ReactHookFormUtil from 'src/util/ReactHookFormUtil';

interface IRHFSelectProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    labelOnLeft?: boolean;
    labelStyle?: React.CSSProperties;
    placeholder?: string;
    name: string;
    options: Array<{ value: string | undefined | number; label: string }>;
    disabled?: boolean;
    rules?: unknown;
    style?: React.CSSProperties;
    defaultVal?: string | number | ReadonlyArray<string>;
    bodyStyle?: React.CSSProperties;
    onChange?: (e: FormEvent<HTMLSelectElement>) => void;
    isRequired?: boolean;
    title?: string;
    id?: string;
    toolTip?: string;
    className?: string;
    spaceLabelContent?: boolean;
}

const RHFSelectInner = (props: IRHFSelectProps) => {
    // See RHFInputBox for why this can't be a naive props.name.split('.') lookup - bracketed array
    // paths like "creditCardDetails[3].billingAccount" need each [n] treated as its own segment.
    const fieldError = ReactHookFormUtil.getNestedError(props.errors, props.name) as { message?: string; } | undefined;

    if (props.labelOnLeft) {
        return (
            <div className="form-field" style={props.bodyStyle}>
                {props.label && (
                    props.spaceLabelContent ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <label htmlFor={props.name} style={{ ...props.labelStyle }}>
                                {props.label}
                                {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                            </label>
                            <select
                                id={!!props?.id ? props.id : props.name}
                                name={props.name}
                                ref={props.register ? props.register(props.rules) : null}
                                style={!!props.disabled ? { cursor: 'not-allowed', ...props.style } : props.style}
                                disabled={props.disabled}
                                onChange={props.onChange}
                                className={`field ${fieldError ? 'error-field' : ''}`}
                                defaultValue={props.defaultVal ? props.defaultVal : ''}
                                title={props.title}
                            >
                                <option key={0} disabled={true} hidden={true} value="">
                                    {props.placeholder || '-- Select --'}
                                </option>
                                {props.options.map((option) => (
                                    <option key={`${props.name}-${option.value}`} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                                {props.toolTip && <span className="tooltiptext">{props.toolTip}</span>}
                            </select>
                        </div>
                    ) : (
                        <div className="form-row">
                            <label htmlFor={props.name} style={{ ...props.labelStyle }}>
                                {props.label}
                                {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                            </label>
                            <select
                                id={!!props?.id ? props.id : props.name}
                                name={props.name}
                                ref={props.register ? props.register(props.rules) : null}
                                style={!!props.disabled ? { cursor: 'not-allowed', ...props.style } : props.style}
                                disabled={props.disabled}
                                onChange={props.onChange}
                                className={`field ${fieldError ? 'error-field' : ''}`}
                                defaultValue={props.defaultVal ? props.defaultVal : ''}
                                title={props.title}
                            >
                                <option key={0} disabled={true} hidden={true} value="">
                                    {props.placeholder || '-- Select --'}
                                </option>
                                {props.options.map((option) => (
                                    <option key={`${props.name}-${option.value}`} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                                {props.toolTip && <span className="tooltiptext">{props.toolTip}</span>}
                            </select>
                        </div>
                    )
                )}
                {
                    fieldError && (
                        <p style={{ color: 'red', marginLeft: '2px' }}>{fieldError.message}</p>
                    )
                }
            </div>
        );
    } else {
        return (
            <div className="form-field" style={props.bodyStyle}>
                {props.label && <label htmlFor={props.name}>
                    {props.label}
                    {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                </label>}
                {props.label && <br />}
                <select
                    id={!!props?.id ? props.id : props.name}
                    name={props.name}
                    ref={props.register ? props.register(props.rules) : null}
                    style={!!props.disabled ? { cursor: 'not-allowed', ...props.style } : props.style}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    className={`field ${fieldError ? 'error-field' : ''}`}
                    defaultValue={props.defaultVal ? props.defaultVal : ''}
                    title={props.title}
                >
                    <option key={0} disabled={true} hidden={true} value="">
                        {props.placeholder || '-- Select --'}
                    </option>
                    {props.options.map((option) => (
                        <option key={`${props.name}-${option.value}`} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <br />
                {fieldError && (
                    <p>{fieldError.message}</p>
                )}
            </div>
        );
    }
};

const RHFSelect = memo(RHFSelectInner);
export default RHFSelect;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFSelect.tsx